module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-422957f89b09a009fdcb8242e4e75a0f.png";